import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const createAdminPaymentCharge = async ({
    token,
    formData,
}) => {

    try {
        const res = await axiosCreate.post('/charge/instance/debtor/payment/admin', formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}

/*
    formData:{
        charge_instance_id,
        place_id,
        charge_instance_debtor_payment_type_id,
        file
    }
*/